import { Component, EventEmitter, Input, Output, ViewEncapsulation, ChangeDetectionStrategy } from "@angular/core";
import { RootsActionMenuItem } from "../..";
import { menuAnimation } from "./roots-action-menu.animations";

@Component({
    selector: "roots-action-menu",
    templateUrl: "./roots-action-menu.component.html",
    styleUrls: ["./roots-action-menu.component.scss"],
    animations: [menuAnimation()],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RootsActionMenuComponent {
  private _items: RootsActionMenuItem[] = [];
  // Info is no longer appended here: the page header's (i) button opens the page info.
  @Input("items") set items(items: RootsActionMenuItem[]) {
    this._items = items ?? [];
  }
  get items() {
    return this._items;
  }

  @Output("onItemClick") onItemClick = new EventEmitter<void>();
  @Output("formClicked") formEmit = new EventEmitter();

  emitAction($event) {
    this.onItemClick.emit($event);
  }
}
